// -----------------------------------------------------------------
// <copyright
//   file="Izenda.ConnectionMasterDbList.js"
//   company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
// </copyright>
// -----------------------------------------------------------------

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { partial } from 'lodash/fp';
import classnames from 'classnames';
import BrowserUtils from 'share/utils/Izenda.BrowserUtils';

/**
 * Choose DB type component
 */
export default class ConnectionMasterDbList extends Component {

  static propTypes = {
    dbTypes: PropTypes.object.isRequired,
    selectedDbType: PropTypes.object,
    onDbTypeSelected: PropTypes.func
  };

  constructor(props) {
    super(props);
    this.state = {
      selectedDbType: props.selectedDbType || null
    };
  }

  /**
   * On db type selected handler
   * @param dbType
   */
  onDbTypeSelect = dbType => {
    const { onDbTypeSelected } = this.props;
    this.setState({
      selectedDbType: dbType
    });
    onDbTypeSelected && onDbTypeSelected(dbType);
  };

  /**
   * Render single database type.
   * @param {Object} dbType Database type object {id, name, shortName}
   * @param {number} index dbtype index
   */
  renderDbType(dbType, index) {
    const selectedDbType = this.state.selectedDbType;
    const name: string = dbType.name;
    const shortName: string = dbType.shortName;
    const onlyName = name && name.substring(name.indexOf(']')+2);
    const dbTypeInnerClasses = classnames('dbTypeInner', {
      'selected': selectedDbType === dbType
    });

    const iconClasses = classnames('izenda-Connection-dbTypeIcon', 'large', shortName);
    const ie11GridStyle = BrowserUtils.isIEBrowser()
      ? {
        'msGridColumn': (index % 4) * 2 + 1,
        'msGridRow': Math.floor(index / 4) * 2 + 1
      }
      : {};

    return (
      <div className="dbType" key={dbType.id} style={ie11GridStyle}>
        <div className={dbTypeInnerClasses} onClick={partial(this.onDbTypeSelect, [dbType])}>
          <div className={iconClasses}/>
          <div className="dbTypeName">{onlyName}</div>
        </div>

      </div>
    );
  }

  render() {
    const { dbTypes } = this.props;

    return (
      <div className="dbTypeList">
        {dbTypes.map((dbType, i) => this.renderDbType(dbType, i))}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./ui/modules/Settings/DataSetup/Connection/ConnectionMaster/Izenda.ConnectionMasterDbList.js